export const isOdd = (number: number) => number % 2 !== 0;
